import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SelectedFilters } from 'src/app/portfolio/state/portfolioGeneralSlice';

export type GnrFiltersState = {
    selectedFilters: SelectedFilters;
    search: string;
    sort: string | null;
    sortDir: string | null;
    page: number;
    // Unlike every other GNR filter, this persists across all GNR views
    // (portfolio and site level) — see setSelectedAt / useSelectedTimePeriod.
    selectedAt: string | null;
};

const initialState: GnrFiltersState = {
    selectedFilters: [],
    search: '',
    sort: null,
    sortDir: null,
    page: 1,
    selectedAt: null,
};

const gnrFiltersSlice = createSlice({
    name: 'gnrFilters',
    initialState,
    reducers: {
        updateGnrFilters: (state, action: PayloadAction<SelectedFilters>) => {
            state.selectedFilters = action.payload;
        },
        resetGnrFilters: state => {
            state.selectedFilters = [];
        },
        syncGnrState: (_state, action: PayloadAction<GnrFiltersState>) => action.payload,
        clearAllGnrState: () => initialState,
        setSelectedAt: (state, action: PayloadAction<string | null>) => {
            state.selectedAt = action.payload;
        },
    },
});

export const { updateGnrFilters, resetGnrFilters, syncGnrState, clearAllGnrState, setSelectedAt } = gnrFiltersSlice.actions;
export default gnrFiltersSlice.reducer;
